import { useQuery } from '@tanstack/react-query';
import { Control, FieldError, FieldValues, Merge, Path } from 'react-hook-form';
import { Liability, PaginatedData } from '../../@types/api';
import { QUERY_KEYS } from '../../constants';
import { getData } from '../../utils/api';
import FormSelect from '../molecules/FormSelect';

type LiabilityLimitSelectProps<T extends FieldValues, TTransformedValues extends FieldValues | undefined = T> = {
  control: Control<T, unknown, TTransformedValues>;
  name: Path<T>;
  label?: string;
  competitionIds?: string | string[];
  error?: Merge<FieldError, (FieldError | undefined)[]>;
  multiple?: boolean;
  closeMenuOnSelect?: boolean;
};

const LiabilityLimitSelect = <T extends FieldValues, TTransformedValues extends FieldValues | undefined = T>({
  control,
  name,
  label,
  error,
  multiple,
  closeMenuOnSelect,
}: LiabilityLimitSelectProps<T, TTransformedValues>) => {
  const { data: liabilityLimitData } = useQuery({
    queryKey: [QUERY_KEYS.liabilities],
    queryFn: (): Promise<PaginatedData<Liability>> => getData('risk-management/liabilities'),
  });
  return (
    <FormSelect
      label={label ?? 'Liability Limit'}
      name={name}
      control={control}
      options={liabilityLimitData?.items || []}
      error={error}
      multiple={multiple}
      closeOnSelect={closeMenuOnSelect}
    />
  );
};

export default LiabilityLimitSelect;
